/**
 * Wraps template variables with span tags with the given classes
 *
 * @param {string} template - string with template variables to wrap in spans
 * @param {string} classes - the classes to add to these spans
 */
export const wrapWithSpans = (template, classes) => template.replace(/\${.*?}/g, `<span ${classes && classes.length ? `class="${classes.join(" ")}"` : ""}>$&</span>`);
